(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Handles video autoplay on hover for card gallery
   */
  (() => {
    const cardGalleries = document.querySelectorAll('.card-gallery');
    
    cardGalleries.forEach((gallery) => {
      const hoverMedia = gallery.querySelector('.card-gallery__hover-media[data-video-media="true"]');
      if (!hoverMedia) return;

      const video = hoverMedia.querySelector('video');
      const deferredMedia = hoverMedia.querySelector('deferred-media[autoplay]');
      
      if (!video && !deferredMedia) return;

      const playVideo = () => {
        if (video) {
          video.muted = true;
          video.play().catch(() => {
            // Ignore autoplay errors
          });
        } else if (deferredMedia) {
          // Trigger deferred media to load and play
          const deferredMediaAny = /** @type {any} */ (deferredMedia);
          if (typeof deferredMediaAny.showDeferredMedia === 'function' && !deferredMediaAny.isPlaying) {
            deferredMediaAny.showDeferredMedia();
          }
        }
      };

      const pauseVideo = () => {
        if (video) {
          video.pause();
        } else if (deferredMedia) {
          const deferredMediaAny = /** @type {any} */ (deferredMedia);
          if (typeof deferredMediaAny.toggleMedia === 'function' && deferredMediaAny.isPlaying) {
            deferredMediaAny.toggleMedia();
          } else {
            // Fallback: pause video/iframe directly
            const iframe = deferredMedia.querySelector('iframe');
            const videoInDeferred = deferredMedia.querySelector('video');
            if (videoInDeferred) {
              videoInDeferred.pause();
            } else if (iframe && iframe.contentWindow) {
              // For YouTube/Vimeo iframes, try to pause via postMessage
              try {
                iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
              } catch (e) {
                // Ignore errors
              }
            }
          }
        }
      };

      // Only handle mouse hover (not touch)
      gallery.addEventListener('mouseenter', playVideo);
      gallery.addEventListener('mouseleave', pauseVideo);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
